export const SUBSCRIPTION_LIST_RECEIVED = "SUBSCRIPTION_LIST_RECEIVED";
export const USER_ACTIVE_SUBSCRIPTION_INFO_RECEIVED =
  "USER_ACTIVE_SUBSCRIPTION_INFO_RECEIVED";
export const SUBSCRIPTION_PROMO_CODE_APPLIED =
  "SUBSCRIPTION_PROMO_CODE_APPLIED";
export const CLEAR_SUBSCRIPTION_PROMO_DETAIL =
  "CLEAR_SUBSCRIPTION_PROMO_DETAIL";
